import { isIncapacitated } from '../../../shared/rules/barbarianRage.mjs';
import { opportunityAttacksAreBlocked } from '../../../shared/rules/effects/directSpellRiders.mjs';
import { getCanonicalCombatantIdentity } from './combatTimeline';
import { applyIncomingDamageModifiers as applyDamageOperations } from '../../../shared/rules/damage/incomingDamage.mjs';

export const UNCANNY_DODGE_FEATURE_ID = 'rogue:uncanny-dodge';

const participantIds = (combat) => new Set((combat?.participants || [])
  .map(getCanonicalCombatantIdentity).filter(Boolean));

export const isReactionProhibited = (combat, combatantId) =>
  isIncapacitated({ combatantId }, {
    activeEffects: (combat?.activeEffects || []).map(effect => ({
      ...effect, targetCombatantId: getCanonicalCombatantIdentity(effect?.targetCombatantId),
    })),
  });

export const getReactionState = (combat, combatantId) =>
  (combat?.reactionStates || []).find((state) =>
    getCanonicalCombatantIdentity(state?.combatantId) === String(combatantId));

/** Class-neutral Reaction availability. A missing state is deliberately available. */
export const canTakeReaction = (combat, combatantId) => Boolean(
  combatantId && participantIds(combat).has(String(combatantId)) &&
  combat?.activeTurn !== null && combat?.activeTurn !== undefined &&
  !getReactionState(combat, combatantId)?.spent &&
  !isReactionProhibited(combat, combatantId)
);

export const applyIncomingDamageModifiers = (rolledAttackDamage, modifiers = []) => {
  const result = applyDamageOperations({ rawDamage: rolledAttackDamage, calculatedDamage: rolledAttackDamage }, modifiers);
  return { rolledAttackDamage: result.rawDamage, incomingDamageModifiers: result.modifiers, finalDamageApplied: result.finalDamage };
};

export const getOwnedPendingReaction = (combat, combatantId) =>
  (combat?.reactionOpportunities || []).find((opportunity) =>
    opportunity?.status === 'pending' &&
    getCanonicalCombatantIdentity(opportunity?.targetCombatantId) === String(combatantId));


// Shocking Grasp blocks this reaction category only, never every Reaction.
export const canMakeOpportunityAttack = (combat, combatantId) => canTakeReaction(combat, combatantId) && !opportunityAttacksAreBlocked(combat, combatantId);

export const defenderDamageModifiers = opportunity => opportunity?.status!=='used'?[]:opportunity.incomingDamageModifiers||[{featureId:'rogue:uncanny-dodge',operation:'halve-floor',parentAttackResolutionId:opportunity.parentAttackResolutionId}];
